import { Button } from '@/components';
import { cn } from '@/utils';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';

const HeaderCreate = ({
	title,
	onClickCreate,
	loading,
	className,
	actions,
	titleSave,
	isShowButtonCreate = true,
	secondaryButton = false,
}: {
	title: string;
	onClickCreate?: React.MouseEventHandler<HTMLElement> | undefined;
	loading?: boolean;
	className?: string;
	actions?: React.ReactNode;
	titleSave?: string;
	isShowButtonCreate?: boolean;
	secondaryButton?: boolean;
}) => {
	const { t } = useTranslation('common');
	return (
		<div
			className={cn(
				'row-between mb-5 container-header-list bg-white h-[60px] mx-[-36px] pl-10 pr-9 border-b border-gray9 shadow-headerList sticky z-[11] top-0 left-0 right-0',
				className
			)}
		>
			<h2 className="font-semibold text-xl text-font3">{title}</h2>
			<div className="flex items-center justify-center gap-[10px]">
				{actions}
				{isShowButtonCreate && (
					<Button
						type="primary"
						isMainBtn
						onClick={onClickCreate}
						loading={loading}
						secondary={secondaryButton}
					>
						{titleSave ? titleSave : t('save')}
					</Button>
				)}
			</div>
		</div>
	);
};

export default memo(HeaderCreate);
